import { __decorate, __extends } from "tslib";
import { body } from "@pnp/odata";
import { defaultPath } from "../decorators.js";
import { graphInvokableFactory, _GraphQueryableInstance } from "../graphqueryable.js";
import { graphPost } from "../operations.js";
/**
 * Search
 */
var _Search = /** @class */ (function (_super) {
    __extends(_Search, _super);
    function _Search() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    _Search.prototype.executeQuery = function (request) {
        return graphPost(Search(this, "query"), body(request));
    };
    _Search = __decorate([
        defaultPath("search")
    ], _Search);
    return _Search;
}(_GraphQueryableInstance));
export { _Search };
export var Search = graphInvokableFactory(_Search);
//# sourceMappingURL=types.js.map